let timer;

const startTimer = (router, logoutURL, seconds = 300) => {
    if (timer) {
        clearTimeout(timer);
    }
    console.log('[session-timeout]', 'Timeout started with [', seconds, '] seconds.')
    timer = setTimeout(function () {
        console.log('[session-timeout]', 'Timeout completed with [', seconds, '] seconds.')
        router.push(logoutURL);
    }, seconds * 1000);
}

export default {
    install(options, axios, onRejected) {

        if (!options) {
            return;
        }

        if (!options.router) {
            return;
        }

        const seconds = options.seconds || 300;
        const router = options.router;
        const logoutUrl = options.url;

        startTimer(router, logoutUrl, seconds);

        axios.interceptors.response.use(function (response) {
            startTimer(router, logoutUrl, seconds);
            return response;
        }, onRejected);

    }
}
